module.exports = __webpack_public_path__ + "static/map-bg1-2d9e36d0855e75a10796b4c9392bbdbd.png";